import { getApp, getApps, initializeApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

import config from "../config";

const firebaseConfig = config.firebase || {};

const hasFirebaseStorageConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId &&
    firebaseConfig.storageBucket
);

const firebaseApp = hasFirebaseStorageConfig
  ? getApps().length > 0
    ? getApp()
    : initializeApp(firebaseConfig)
  : null;

const firebaseStorage = firebaseApp ? getStorage(firebaseApp) : null;

export const isFirebaseStorageEnabled = Boolean(firebaseStorage);

export const uploadProfileImageToFirebase = async (membershipId, file) => {
  if (!firebaseStorage) {
    throw new Error("Firebase Storage is not configured");
  }

  const fileExtension = (file.name.split(".").pop() || "jpg").toLowerCase();
  const safeExtension = fileExtension === "jpeg" ? "jpg" : fileExtension;
  const storagePath = `profile-images/${membershipId}.${safeExtension}`;

  const storageRef = ref(firebaseStorage, storagePath);
  await uploadBytes(storageRef, file, {
    contentType: file.type,
    cacheControl: "public,max-age=3600",
  });

  return storagePath;
};

export const resolveProfileImageUrl = async (profileImage) => {
  if (!profileImage) {
    return "";
  }

  if (/^https?:\/\//i.test(profileImage)) {
    return profileImage;
  }

  if (firebaseStorage && profileImage.startsWith("profile-images/")) {
    try {
      return await getDownloadURL(ref(firebaseStorage, profileImage));
    } catch (error) {
      console.error("Failed to resolve Firebase profile image URL", error);
    }
  }

  return "";
};
